module.exports = __webpack_public_path__ + "static/media/settings.6329d8ca.svg";